<footer [style.color]="data?.textColor" class="footer">
  <ng-container *ngIf="footer">
    <div class="footer__container">
      <div class="footer__row footer__order">
        <div *ngIf="info$ | async as info" class="footer__col footer__order-1">
          <h3>{{ info.header }}</h3>
          <p>{{ info.address }}</p>
          <p>{{ info.address2 }}</p>
          <p>
            <a href="mailto:{{ info.email }}">{{ info.email }}</a>
          </p>
          <a href="tel:{{ info.phone }}"
            ><p>{{ info.phone }}</p></a
          >
          <p>{{ info.cvrNumber }}</p>
          <div class="footer__social-media">
            <a
              *ngIf="info.facebookPage"
              href="{{ info.facebookPage.url }}"
              target="{{ info.facebookPage.target }}"
              ><svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="facebook-square"
                class="svg-inline--fa fa-facebook-square fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
              >
                <path
                  fill="currentColor"
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                /></svg
            ></a>
            <a
              *ngIf="info.linkedInPage"
              href="{{ info.linkedInPage.url }}"
              target="{{ info.linkedInPage.target }}"
              ><svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="linkedin"
                class="svg-inline--fa fa-linkedin fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"
                /></svg
            ></a>
            <a
              *ngIf="info.youtubePage"
              href="{{ info.youtubePage.url }}"
              target="{{ info.youtubePage.target }}"
              ><svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="youtube"
                class="svg-inline--fa fa-youtube fa-w-18"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  fill="currentColor"
                  d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                ></path></svg
            ></a>
          </div>
        </div>
        <div class="footer__col footer__order-2">
          <h3>{{ footer.header }}</h3>
          <p *ngFor="let item of footer?.items">
            <a *ngIf="item" href="{{ item.url }}" target="{{ item.target }}">{{
              item.name
            }}</a>
          </p>
        </div>
        <div
          *ngIf="footer.googlePlayPage || footer.appleStorePage"
          class="footer__col footer__apps footer__order-3"
        >
          <h3>{{ "footer.ThirdTitle" | translate }}</h3>
          <div class="footer__apps-img">
            <p *ngIf="footer.googlePlayPage?.url">
              <a href="{{ footer.googlePlayPage.url }}" target="_blank">
                <img
                  src="wwwroot/assets/img/google-play.png"
                  alt="Google Play"
                  loading="lazy"
                />
              </a>
            </p>
            <p *ngIf="footer.appleStorePage?.url">
              <a href="{{ footer.appleStorePage.url }}" target="_blank">
                <img
                  src="wwwroot/assets/img/app-store.png"
                  alt="App Store"
                  loading="lazy"
                />
              </a>
            </p>
          </div>
        </div>
        <div class="footer__col footer__signup footer__order-4 subscribe">
          <ubl-subscribe-panel
            *ngIf="footerSubscription"
            [data]="footerSubscription"
          ></ubl-subscribe-panel>
        </div>
      </div>
    </div>
  </ng-container>
</footer>
